<template>
  <div>
    <div class="flex flex-row gap-2 mb-2">
      <b-button
        v-permission="'campaigns.create'"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="addNew">
        <feather-icon icon="PlusIcon" class="mr-50"/>
        <span class="align-middle">{{ $t('AddNew') }}</span>
      </b-button>

      <b-button v-permission="'campaigns.approve'" variant="outline-primary" @click="goToApprovals">
        <feather-icon icon="CheckSquareIcon" class="mr-50"/>
        <span class="align-middle">{{ $t('campaign.approvals') }}</span>
        <b-badge v-if="awaitingCount > 0" variant="warning" class="ml-50">{{ awaitingCount }}</b-badge>
      </b-button>
    </div>

    <Grid :service="service" route_name="campaigns" order_column="id">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('campaign.name') }}</vs-th>
        <vs-th key="window">{{ $t('campaign.window') }}</vs-th>
        <vs-th key="offer">{{ $t('campaign.offer') }}</vs-th>
        <vs-th key="budget">{{ $t('campaign.budget') }}</vs-th>
        <vs-th key="status" sort-key="status">{{ $t('campaign.status') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">{{ tr.id }}</vs-td>
          <vs-td width="28%" key="name">
            <div class="font-medium">{{ tr.name }}</div>
            <small class="text-muted">{{ _.get(tr, 'legal_entity.name') }}</small>
          </vs-td>
          <vs-td width="17%" key="window">
            <small>{{ windowLabel(tr) }}</small>
          </vs-td>
          <vs-td width="20%" key="offer">
            <small>
              {{ $t('campaign.discount') }}: {{ amountLabel(tr.discount_type, tr.discount_amount) }}<br/>
              {{ $t('campaign.commission') }}: {{ amountLabel(tr.commission_type, tr.commission_amount) }}
            </small>
          </vs-td>
          <vs-td width="15%" key="budget">
            <small v-if="tr.budget_cap_cents">
              {{ money(tr.budget_spent_cents) }} / {{ money(tr.budget_cap_cents) }}
            </small>
            <small v-else class="text-muted">{{ $t('campaign.no_budget_cap') }}</small>
          </vs-td>
          <vs-td width="10%" key="status">
            <vs-chip transparent :color="statusColor(tr.status)" class="text-base">
              {{ $t(`campaign.status_.${tr.status}`) }}
            </vs-chip>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'campaigns.show'"
                icon="EyeIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
                @click="openDetail(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'campaigns.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'campaigns.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton, BBadge } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import CampaignService from '@/services/api/CampaignService'

export default {
  directives: { Ripple },
  components: { BButton, BBadge },
  data: () => ({ service: null, awaitingCount: 0 }),
  methods: {
    addNew() { this.$router.push('/campaigns/create') },
    goToApprovals() { this.$router.push('/campaigns/approvals') },
    openDetail(id) { this.$router.push(`/campaigns/${id}/detail`) },
    amountLabel(type, amount) {
      const n = Number(amount || 0)
      return type === 'VA' ? this.money(n * 100) : `${n}%`
    },
    money(cents) {
      return (Number(cents || 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    windowLabel(campaign) {
      const fmt = v => (v ? new Date(v).toLocaleDateString('pt-BR') : '—')
      return `${fmt(campaign.starts_at)} → ${fmt(campaign.ends_at)}`
    },
    statusColor(status) {
      switch (status) {
        case 'AC': return 'success'
        case 'PA': return 'warning'
        case 'PU': return 'warning'
        case 'DR': return 'dark'
        case 'CA': return 'danger'
        case 'RJ': return 'danger'
        default: return 'primary'
      }
    },
    loadAwaiting() {
      this.service.awaitingApproval().then(
        list => { this.awaitingCount = (list || []).length },
        () => { this.awaitingCount = 0 }
      )
    }
  },
  beforeMount() { this.service = CampaignService.build(this.$vs) },
  mounted() { this.loadAwaiting() }
}
</script>
